const styles = theme => ({
  root: {
    padding: "2px 4px",
    display: "flex",
    alignItems: "center",
    width: 400
  },
  content: {
    marginTop: "40px"
  },
  logo: {
    width: "150px",
    display: "block",
    marginLeft: "10px",
    marginTop: "auto",
    marginBottom: "auto"
  },
  footer: {
    position: "fixed",
    bottom: "0",
    width: "100%",
    display: "flex",
    justifyContent: "center"
  }
});

export default styles;
